module.exports = __webpack_public_path__ + "img/2.b1b159ef.png";